import { defaultEmployerFormValues, EmployerFormValues } from "../common/EmployerFormValues";
import { defaultHospitalIndemnityFormValues, HospitalIndemnityFormValues } from "./HospitalIndemnityFormValues";
import { Taxation } from "../enums/Taxation";

export type HospitalIndemnityEmployerFormValues = EmployerFormValues & HospitalIndemnityFormValues
    & {
    hoursWorkedPerWeek: string,
    employeeContributionPercentage: string,
    premiumTaxation: Taxation
    hospitalIndemnityEmployeeContributionPercentage: string,
    hospitalIndemnityPremiumTaxation: Taxation
}

export const defaultHospitalIndemnityEmployerFormValues = {
    ...defaultEmployerFormValues,
    ...defaultHospitalIndemnityFormValues,
    hoursWorkedPerWeek: '',
    employeeContributionPercentage: '',
    premiumTaxation: '',
    hospitalIndemnityEmployeeContributionPercentage: '',
    hospitalIndemnityPremiumTaxation: ''
}